import React from 'react';

import parser, { Tag } from 'bbcode-to-react';
// import IconDisc from '@material-ui/icons/FiberManualRecord';

class TitleTag extends Tag {
  toReact() {
    // using this.getComponents() to get children components.
    return (
      <Subheader>{this.getComponents()}</Subheader>
    );
  }
}
class PTag extends Tag {
  toReact() {
    // using this.getComponents() to get children components.
    return (
      <p>{this.getComponents()}</p>
    );
  }
}

parser.registerTag('title', TitleTag); // add new tag
parser.registerTag('p', PTag); // add new tag

// class TestComp extends React.Component {
//   render() {
//     return <span>{this.props.children}</span>
//   }
// }
class Prettyfier extends React.Component {
  render() {
    const { text, className, transformBullets } = this.props;
    // return (<span className={className}>{parser.toReact(text)}</span>);
    let rText = text;
    // console.log(transformBullets)
    if (transformBullets !== false) {
      rText = text.replace(/\. /g, '&ofcir; ').replace(/ \./g, ' &ofcir;');
      rText = rText.replace(/\+ /g, '&oplus; ').replace(/ \+/g, ' &oplus;');
    }
    return (<span className={className} dangerouslySetInnerHTML={{__html:parser.toReact(rText)}}></span>);
  }
}

export default Prettyfier;



// WEBPACK FOOTER //
// ./src/components/Prettyfier.jsx